import React from "react";
import Navbar from "../components/Navbar";
import Partner from "../components/Partner";
import Aside from "../components/Aside";
import Footer from "../components/Footer";

const PartnerPage = () => {
  return (
    <>
      <Navbar />
      <Partner />
      <Aside />
      <Footer />
    </>
  );
};

export default PartnerPage;
